import { Authenticator } from '@aws-amplify/ui-react';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { QueryClientProvider } from '@tanstack/react-query';
import { Provider } from 'jotai';
import { useFlags } from 'launchdarkly-react-client-sdk';
import * as React from 'react';
import { RouterProvider } from 'react-router';

import jotaiStore from 'atoms/store';
import Loading from 'components/Loading';
import { queryClient } from 'utils/api';

import { getRouter } from './Routes';

export function App() {
  return (
    <React.StrictMode>
      <Authenticator.Provider>
        <Provider store={jotaiStore}>
          <QueryClientProvider client={queryClient}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <React.Suspense fallback={<Loading />}>
                <Router />
              </React.Suspense>
            </LocalizationProvider>
          </QueryClientProvider>
        </Provider>
      </Authenticator.Provider>
    </React.StrictMode>
  );
}

function Router() {
  const flags = useFlags();
  const router = getRouter({ hasCardOptimizerV2: flags.hasCardOptimizerV2 });

  return <RouterProvider router={router} />;
}
